import { ToolHeadState } from 'types/tools/ToolHeadState';

export default function getToolHeadStateLabel(versionState: ToolHeadState): string {
  switch (versionState) {
    case ToolHeadState.DRAFT:
      return 'Draft';
    case ToolHeadState.ACTIVE:
      return 'Active';
    case ToolHeadState.INACTIVE:
      return 'Inactive';
    default:
      throw new Error(`Unknown tool version state '${versionState}'.`);
  }
}
